import React from 'react';
import AssessmentsView from '../Assessments/AssessmentsView';
import { useRouteMatch } from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';
import { joinPath } from '../../utils/helpers';
import { useHistory } from 'react-router';

function InfosecAssessment({ parentMatch, variant = 'infosec' }) {
    const match = useRouteMatch();
    const history = useHistory();
    const { assessmentStore, authStore, questionStore } = useStores();
    const { currentUser } = authStore;
    const handleOnFinish = () => {
        history.push(joinPath(parentMatch.url, 'finish'));
    };

    return (
        <AssessmentsView
            match={match}
            parentUrl={parentMatch && parentMatch.url}
            currentUser={currentUser}
            companyId={variant}
            assessmentId={variant}
            assessmentStore={assessmentStore}
            questionStore={questionStore}
            language={'en'}
            isInfosec={true}
            onClose={handleOnFinish}
            availableLanguages={['en', 'is']}
        />
    );
}

export default InfosecAssessment;
